import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { GoogleMapsModule } from '@angular/google-maps';
import { EnodePage } from './enode.page';
import { BatteryDoughnutComponent } from './battery-doughnut/battery-doughnut.component';
import { InterventionModalComponent } from './intervention-modal/intervention-modal.component';
import { MapComponent } from './map/map.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { SetupComponent } from './setup/setup.component';
import { DeadlinePickerComponent } from './deadline-picker/deadline-picker.component';
import { SmartChargingComponent } from './smart-charging/smart-charging.component';
import { VehicleComponent } from './vehicle/vehicle.component';
import { AddLocationModalComponent } from './add-location-modal/add-location-modal.component';
import { ChartComponent } from './smart-charging/chart/chart.component';
import { ComponentsModule } from 'src/app/shared/components.module';
import { AdminMenuModalComponent } from './admin-menu-modal/admin-menu-modal.component';
import { StatusIconComponent } from './vehicle/status-icon/status-icon.component';
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { ShowChargingLocationModalComponent } from './show-charging-location-modal/show-charging-location-modal.component';
import { SmartChargeOverrideComponent } from './smart-charge-override/smart-charge-override.component';
import { SmartChargeInfoModalComponent } from './smart-charge-info-modal/smart-charge-info-modal.component';
import { EventLogModalComponent } from './event-log-modal/event-log-modal.component';
import { ChargingLocationComponent } from './charging-location/charging-location.component';
import { UnlinkVendorModalComponent } from './admin-menu-modal/unlink-vendor-modal/unlink-vendor-modal.component';
import { routes } from './enode.routes';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    GoogleMapsModule,
    RouterModule.forChild(routes),
    ComponentsModule
  ],
  declarations: [
    EnodePage,
    BatteryDoughnutComponent,
    InterventionModalComponent,
    OnboardingComponent,
    SetupComponent,
    DeadlinePickerComponent,
    MapComponent,
    SmartChargingComponent,
    VehicleComponent,
    AddLocationModalComponent,
    ChartComponent,
    AdminMenuModalComponent,
    StatusIconComponent,
    LocationPickerComponent,
    ShowChargingLocationModalComponent,
    SmartChargeInfoModalComponent,
    EventLogModalComponent,
    SmartChargeOverrideComponent,
    ChargingLocationComponent,
    UnlinkVendorModalComponent
  ]
})
export class EnodePageModule {}
